import { render, staticRenderFns } from "./SliderProduct.vue?vue&type=template&id=155890a6&scoped=true&"
import script from "./SliderProduct.vue?vue&type=script&lang=js&"
export * from "./SliderProduct.vue?vue&type=script&lang=js&"
import style0 from "./SliderProduct.vue?vue&type=style&index=0&id=155890a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155890a6",
  null
  
)

export default component.exports